<script>
import { mapActions } from 'vuex'
import ModalFormMixin from '@lib/mixins/modal-form'

export default {
  name: 'ProductCategoryModal',
  mixins: [ModalFormMixin],
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      processing: false,
      form: {
        name: '',
        priority: '',
      },
      rules: {
        name: {
          required: true,
          message: 'This field is required',
          trigger: 'blur',
        },
        priority: {
          required: true,
          message: 'This field is required',
          trigger: 'blur',
        },
      },
    }
  },
  created() {
    if (this.edit) {
      this.form = { ...this.category }
    }
  },
  methods: {
    ...mapActions('categories', ['createCategory', 'updateCategory']),
    ...mapActions('manage', ['getAvailableProducts']),
    async onSubmit() {
      const { edit, form } = this
      const formValid = await this.$refs.form.validate().catch(() => false)

      if (!formValid) return
      this.processing = true

      form.priority = parseInt(form.priority)

      const response = edit ? await this.updateCategory(form) : await this.createCategory(form)

      this.$notifier({
        response,
        errorTitle: `Unable to ${edit ? 'update' : 'create'} Category Product`,
        successTitle: `Category Product ${edit ? 'updated' : 'created'}`,
        successMsg: `Category Product ${this.form.name} was successfully ${edit ? 'updated' : 'created'}`,
      }).then(success => {
        if (success) {
          if (this.edit) {
            this.$emit('refresh')
            this.$emit('update:visible', false)
            this.getAvailableProducts()
          } else {
            this.$router.push({
              name: 'product-category',
              params: {
                id: success.id,
              },
            })
          }
        }
      })
      this.processing = false
    },
  },
}
</script>

<template>
  <form-dialog
    :title="`${edit ? 'Edit' : 'Create'} Product Category`"
    :check-form-changed="checkIfFormChanged"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      :disabled="processing"
      :rules="rules"
    >
      <el-form-item
        label="Product Category Name"
        prop="name"
      >
        <el-input v-model="form.name" />
      </el-form-item>

      <el-form-item
        label="Priority Ranking"
        prop="priority"
      >
        <el-input
          v-model="form.priority"
          type="number"
        />
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      :class="$style.save"
      :loading="processing"
      @click="onSubmit"
    >
      {{ `${ edit ? 'Update': 'Create'}` }}
    </el-button>
  </form-dialog>
</template>

<style lang="scss" module>
.save {
  display: block;
  width: 15rem;
  margin: 0 auto;
}
</style>
